export function loadScript(src: string) {
	return new Promise((resolve, reject) => {
		const script = document.createElement("script");

		script.type = "text/javascript";
		script.async = true;
		script.addEventListener("load", () => {
			resolve({});
		});
		script.addEventListener("error", () => {
			reject({});
		});

		script.src = src;
		document.head.appendChild(script);
	});
}

/* eslint-disable no-magic-numbers */
export function timeToSeconds(value) {
	const parts = value.split(":");

	if (parts.length === 2) {
		return (parseFloat(parts[0]) * 60) + parseFloat(parts[1]);
	}

	return 0;
}
